import { UiColumnModel } from "../../models";

export function mockUiColumnModel({
    id = "column-1234",
    type = "uiColumn",
    locale = "en",
    content = mockUiColumnModelContent()
}: Partial<UiColumnModel> = {}): UiColumnModel {
    return {
        id,
        type,
        locale,
        content
    };
}

export type UiColumnModelContent = UiColumnModel["content"];

export function mockUiColumnModelContent({
    title = "Lorem ipsum",
    ...optionals
}: Partial<UiColumnModelContent> = {}): UiColumnModelContent {
    return {
        title,
        ...optionals
    };
}
